/* NIHON: the mega menu products carousel lives inside a closed <details>, so
   Dawn's SliderComponent measures zero-width slides at connect and never
   computes its paging (Dawn's ResizeObserver re-init is a race that often
   misses the panel opening). Re-initialise the slider each time the panel
   opens, when the slides have real geometry. */
class NihonMegaProducts extends HTMLElement {
  connectedCallback() {
    this.details = this.closest('details');
    this.slider = this.querySelector('slider-component');
    if (!this.details || !this.slider) return;
    this.details.addEventListener('toggle', () => {
      // Synchronous on purpose: initPages only reads clientWidths, which
      // forces layout, and a requestAnimationFrame here can stall in
      // backgrounded or headless contexts.
      if (this.details.open) this.slider.resetPages();
    });
  }
}
customElements.define('nihon-mega-products', NihonMegaProducts);
